/** The course frame's arrival-focus rule (#1393 R6); see `course-frame.tsx`. */
import { useLayoutEffect, useRef, type RefObject } from "react";
import { useSearchParams } from "react-router";

/**
 * Whether a visit holds the address, read when an effect runs rather than as
 * its dependency. An open visit owns focus (VisitHost: entry focuses the visit
 * heading, Return focuses the opener), so the frame's arrival focus yields to
 * it and never re-runs because a visit closed.
 */
export function useVisitOpen(): RefObject<boolean> {
  const [params] = useSearchParams();
  const visiting = params.has("visit");
  const open = useRef(visiting);
  useLayoutEffect(() => {
    open.current = visiting;
  });
  return open;
}

/** Focus the frame's `h1` on arrival. The band's heading is not in the tab order until the frame asks. */
export function focusFrameHeading(heading: HTMLElement | null, visitOpen: RefObject<boolean>) {
  if (!heading || visitOpen.current) return;
  if (!heading.hasAttribute("tabindex")) heading.tabIndex = -1;
  heading.focus({ preventScroll: true });
}
